import { render, staticRenderFns } from "./PDFPreview.vue?vue&type=template&id=6040454a"
import script from "./PDFPreview.vue?vue&type=script&lang=ts"
export * from "./PDFPreview.vue?vue&type=script&lang=ts"
import style0 from "./PDFPreview.vue?vue&type=style&index=0&id=6040454a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports